export const ibuOptions = [
    {
        label: 'Low (<15)',
        value: '0,15',
    },
    {
        label: 'Light (16-25)',
        value: '16,25',
    },
    {
        label: 'Moderate (26-40)',
        value: '26,40',
    },
    {
        label: 'High (41-70)',
        value: '41,70',
    },
    {
        label: 'Extremely High (>71)',
        value: '71,120',
    },
]
